import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumModel } from '../constants/models';

@Injectable({
  providedIn: 'root',
})
export class EnumsService {
  baseUrl: string = '/settings/api/EnumValues';

  constructor(private http: HttpClient) {}

  getAllEnums(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/all`);
  }

  getRequestTypes(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/request-type`);
  }

  getApplicationStatuses(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/application-status`);
  }

  getApplicationResultApprovalStatuses(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(
      `${this.baseUrl}/application-result-approval-status`
    );
  }

  getGenderTypes(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/gender-type`);
  }

  getInspectionTypes(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/inspection-type`);
  }

  getQuestionDifficultyLevels(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(
      `${this.baseUrl}/question-difficulty-level`
    );
  }

  getTemplateTypes(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/template-type`);
  }

  getCocResults(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/coc-result`);
  }

  getTeachingMethodologies(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/teaching-methodology`);
  }

  getQuestionTypes(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/question-type`);
  }

  getOwnershipTypes(): Observable<EnumModel[]> {
    return this.http.get<EnumModel[]>(`${this.baseUrl}/ownership-type`);
  }

  getGenders(): Observable<any[]> {
    return this.http.get<any[]>(`/settings/api/Genders`);
  }
}
